var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _vm.show
                  ? _c(
                      "b-form",
                      {
                        class: [_vm.inline ? "gap-2 items-center" : ""],
                        attrs: { inline: _vm.inline },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.onSubmit($event)
                          },
                          reset: [
                            function($event) {
                              $event.preventDefault()
                              return _vm.clear($event)
                            },
                            _vm.onReset
                          ]
                        }
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "v-row" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "v-col-sm-12 v-col-md-12 v-col-lg-8"
                              },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("document_title"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(validationContext) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "input-group-1",
                                                  label: _vm.$t(
                                                    "document_title"
                                                  ),
                                                  "label-for": "document_title"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id: "document_title"
                                                  },
                                                  model: {
                                                    value: _vm.item.title,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "title",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.title"
                                                  }
                                                }),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    class: [
                                                      { absolute: _vm.inline }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          validationContext
                                                            .errors[0]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t("document_category"),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(validationContext) {
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "input-group-2",
                                                  label: _vm.$t(
                                                    "document_category"
                                                  ),
                                                  "label-for":
                                                    "document_category"
                                                }
                                              },
                                              [
                                                _c("b-form-select", {
                                                  staticClass:
                                                    "required-select",
                                                  attrs: {
                                                    id: "document-category",
                                                    options:
                                                      _vm.documentCategories,
                                                    "text-field": "name",
                                                    "value-field": "id"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.item
                                                        .document_category_id,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "document_category_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.document_category_id"
                                                  }
                                                }),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    class: [
                                                      { absolute: _vm.inline }
                                                    ]
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          validationContext
                                                            .errors[0]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-3",
                                      label: _vm.$t("document_description"),
                                      "label-for": "document_description"
                                    }
                                  },
                                  [
                                    _c("simple-editor", {
                                      staticClass: "mb-2",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "v-col-sm-12 v-col-md-12 v-col-lg-4 border-4 border-red-200 border-x-red-500 mx-auto max-w-md"
                              },
                              [
                                _c("h5", { staticClass: "mr-1" }, [
                                  _vm._v(_vm._s(_vm.$t("document_security")))
                                ]),
                                _c("vs-divider", {
                                  attrs: { color: "warning" }
                                }),
                                _c("b-form-group", {
                                  attrs: { label: _vm.$t("document_access") },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var ariaDescribedby =
                                            ref.ariaDescribedby
                                          return [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                id: "btn-radios-2",
                                                options: _vm.mediaAccessList,
                                                "aria-describedby": ariaDescribedby,
                                                "button-variant":
                                                  "outline-primary",
                                                name: "radio-btn-outline",
                                                size: "sm",
                                                buttons: ""
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.handlingRadioAccess(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.item.media_access,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "media_access",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.media_access"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("document_access_by_code"),
                                      "label-for": "accessByCode"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-radio-group",
                                      {
                                        attrs: {
                                          id: "accessByCode",
                                          name: "accessByCode"
                                        },
                                        model: {
                                          value: _vm.item.access_by_code,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.item,
                                              "access_by_code",
                                              $$v
                                            )
                                          },
                                          expression: "item.access_by_code"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-radio",
                                          { attrs: { value: true } },
                                          [_vm._v(_vm._s(_vm.$t("yes")))]
                                        ),
                                        _c(
                                          "b-form-radio",
                                          { attrs: { value: false } },
                                          [_vm._v(_vm._s(_vm.$t("no")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-6",
                                      label: _vm.$t("document_password"),
                                      "label-for": "document_password"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { id: "document_password" },
                                      model: {
                                        value: _vm.item.password,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "password", $$v)
                                        },
                                        expression: "item.password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("vs-divider", {
                                  attrs: { color: "warning" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-row justify-end gap-4 mt-2"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  disabled: !valid
                                }
                              },
                              [_vm._v("Salvar")]
                            ),
                            _vm.isEdit()
                              ? _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "documents.data_access",
                                        expression: "'documents.data_access'"
                                      }
                                    ],
                                    staticClass:
                                      "btn waves-effect outline-primary",
                                    attrs: {
                                      type: "button",
                                      variant: "outline-secondary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showDataAccess = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("action.colaboration")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v("Voltar")]
                            )
                          ],
                          1
                        ),
                        _vm.isEdit() && !_vm.item.access_by_code
                          ? _c(
                              "b-row",
                              { staticClass: "m-0" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "12" } },
                                  [
                                    _c("vs-divider"),
                                    _c("b-card-code", {
                                      key: _vm.id,
                                      attrs: {
                                        title:
                                          "URL pública (Somente quando o acesso não for pelo token)",
                                        codeVisible: "true",
                                        showCopy: "true"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "code",
                                            fn: function() {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.item.public_url
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "m-0" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "12" } },
                                  [
                                    _c("h5", { staticClass: "mt-2 mb-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("document_subtitle_document")
                                        )
                                      )
                                    ]),
                                    _c("vs-divider")
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "pt-2 pb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "12", md: "12" } },
                                  [
                                    _c(
                                      "vue-dropzone",
                                      {
                                        ref: "fileUploadZone",
                                        attrs: {
                                          id: "upload",
                                          "use-font-awesome": true,
                                          options: _vm.dropzoneOptions,
                                          "use-custom-dropzone-options": true,
                                          useCustomSlot: true
                                        },
                                        on: {
                                          "vdropzone-processing":
                                            _vm.dropzoneChangeUrl,
                                          "vdropzone-success":
                                            _vm.successSendFile,
                                          "vdropzone-error": _vm.error,
                                          "vdropzone-file-added": [
                                            _vm.added,
                                            _vm.fileAdded
                                          ],
                                          "vdropzone-queue-complete":
                                            _vm.complete
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropzone-custom-content"
                                          },
                                          [
                                            _vm._v(
                                              " Arraste e solte para enviar um arquivo "
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "separator" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "separator-span"
                                                  },
                                                  [_vm._v(" ou ")]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn waves-effect outline-primary",
                                                attrs: {
                                                  type: "button",
                                                  variant: "outline-secondary"
                                                }
                                              },
                                              [_vm._v("Selecionar")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "pt-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "12" } },
                                  [
                                    _c("media-list", {
                                      attrs: {
                                        medias: _vm.files,
                                        "show-delete": true,
                                        "action-on-click": false
                                      },
                                      on: { deleteMedia: _vm.deleteMedia }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm.item.media_access === "GROUP"
        ? _c("role-popup", {
            attrs: {
              visible: _vm.showPopupRole,
              idsSelected: _vm.idsRolesSelected
            },
            on: {
              selected: _vm.addRolesList,
              close: function($event) {
                _vm.showPopupRole = false
              }
            }
          })
        : _vm._e(),
      _c(
        "vs-popup",
        {
          attrs: {
            title: _vm.$t("document_colaboration"),
            active: _vm.showDataAccess
          },
          on: {
            "update:active": function($event) {
              _vm.showDataAccess = $event
            }
          }
        },
        [
          _vm.$acl.hasPermission("documents.data_access")
            ? _c("data-access-form", {
                attrs: { modelType: "documents", modelId: _vm.id }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }